import { ref, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createElementVNode as _createElementVNode, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-436008af"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 2
};
const _hoisted_2 = {
  key: 3
};
const _hoisted_3 = {
  style: {
    "max-height": "360px",
    "overflow-y": "auto"
  }
};
const _hoisted_4 = {
  style: {
    "margin-top": "12px"
  }
};
import useDetailHooks from "@/views/goodsManage/goodsSetting/hooks/useDetailHooks";
import { usePass } from "@/views/goodsManage/goodsSetting/hooks/usePass";
import { LoadingOutlined } from "@ant-design/icons-vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'WeiXinGameJudgeModal',
  props: {
    modalVisible: {
      type: Boolean,
      required: true
    },
    dataSource: {
      type: Array,
      required: true
    },
    prodChnl: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modalVisible", "searchData", "updateStatistics"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const progressMap = new Map([["begin", "开始"], ["progress", "执行中"], ["success", "执行成功"], ["warn", "执行异常"], ["error", "执行失败"], ["complete", "执行结束"]]);
    const prodChnlRef = ref(props.prodChnl);
    const {
      prodTypeOptions
    } = useDetailHooks();
    const {
      loading,
      submitJudgeAndPass,
      syncProductSSEMessage,
      sseMessageLoading,
      sseMessageModal,
      handleSSEMessageModalOk
    } = usePass(prodChnlRef, () => {
      emit("update:modalVisible", false);
      emit("searchData");
      emit("updateStatistics");
    });
    const columns = [{
      title: "商品类型",
      dataIndex: "prodType"
    }, {
      title: "内购ID",
      dataIndex: "prodId"
    }, {
      title: "系统",
      dataIndex: "os",
      width: 120
    }, {
      title: "商品名称",
      dataIndex: "prodName",
      key: "prodName"
    }, {
      title: "当前价格",
      dataIndex: "prodPrice",
      key: "prodPrice"
    }, {
      title: "测试状态",
      dataIndex: "testStatus",
      key: "testStatus"
    }, {
      title: "审核类型",
      dataIndex: "optType",
      key: "optType"
    }, {
      title: "审核建议",
      dataIndex: "optReason",
      key: "optReason"
    }];
    // 版号小游戏列
    const versionColumns = [{
      title: '商品类型',
      dataIndex: 'prodType',
      key: 'prodType'
    }, {
      title: '内购ID',
      dataIndex: 'prodId',
      key: 'prodId'
    }, {
      title: '商品名称',
      dataIndex: 'prodName',
      key: 'prodName'
    }, {
      title: '默认价格',
      dataIndex: 'prodPrice',
      key: 'prodPrice'
    }, {
      title: '审核类型',
      dataIndex: 'optType',
      key: 'optType'
    }];
    const osList = [{
      label: "安卓",
      value: 1
    }, {
      label: "ios",
      value: 2
    }];
    const optTypeList = [{
      label: "新增商品",
      value: 0
    }, {
      label: "修改商品",
      value: 10
    }, {
      label: "下线",
      value: 20
    }, {
      label: "上线",
      value: 30
    }];
    const closeModal = () => {
      emit("update:modalVisible", false);
    };
    const handleReason = record => {
      var _props$dataSource, _props$dataSource2, _list$, _list$2;
      const prodIdNum = (_props$dataSource = props.dataSource) === null || _props$dataSource === void 0 ? void 0 : _props$dataSource.filter(item => item.prodId === record.prodId).length;
      if (prodIdNum === 1) return "该内购ID 安卓/iOS端商品未同步提审，请确认，避免遗漏";
      const list = ((_props$dataSource2 = props.dataSource) === null || _props$dataSource2 === void 0 ? void 0 : _props$dataSource2.filter(item => item.prodId === record.prodId)) || [];
      if (list[0].testStatus !== (list === null || list === void 0 ? void 0 : list[1].testStatus)) return "双端测试状态不一致";
      if (((_list$ = list[0]) === null || _list$ === void 0 ? void 0 : _list$.prodPrice) !== (list === null || list === void 0 || (_list$2 = list[1]) === null || _list$2 === void 0 ? void 0 : _list$2.prodPrice)) return "双端价格不一致";
      return "";
    };
    watch(() => props.prodChnl, n => {
      prodChnlRef.value = n;
    });
    return (_ctx, _cache) => {
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_a_modal, {
        title: "请审核，点击发布后以下信息将在线上立即生效",
        width: "1200px",
        centered: "",
        open: __props.modalVisible,
        onCancel: closeModal,
        onOk: _cache[0] || (_cache[0] = $event => _unref(submitJudgeAndPass)(__props.dataSource)),
        "confirm-loading": _unref(loading),
        maskClosable: false,
        "ok-text": "发布",
        "cancel-text": "稍后"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_table, {
          columns: __props.prodChnl === 'BanHao' ? versionColumns : columns,
          "data-source": __props.dataSource,
          pagination: false,
          scroll: {
            y: 600
          }
        }, {
          bodyCell: _withCtx(({
            column,
            record
          }) => {
            var _unref$find, _osList$find, _optTypeList$filter$;
            return [column.dataIndex === 'prodType' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString((_unref$find = _unref(prodTypeOptions).find(item => item.value === record.prodType)) === null || _unref$find === void 0 ? void 0 : _unref$find.label), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'os' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createTextVNode(_toDisplayString((_osList$find = osList.find(item => item.value === record.os)) === null || _osList$find === void 0 ? void 0 : _osList$find.label), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodPrice' ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(record["prodPriceCurrency"]) + _toDisplayString(record["prodPrice"]), 1)) : _createCommentVNode("", true), column.dataIndex === 'testStatus' ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(!record["testStatus"] ? "-" : "测试中"), 1)) : _createCommentVNode("", true), column.dataIndex === 'optType' ? (_openBlock(), _createElementBlock("span", {
              key: 4,
              class: _normalizeClass({
                red: [10, 20].includes(record.optType)
              })
            }, _toDisplayString((_optTypeList$filter$ = optTypeList.filter(item => item.value === record.optType)[0]) === null || _optTypeList$filter$ === void 0 ? void 0 : _optTypeList$filter$.label), 3)) : _createCommentVNode("", true), column.dataIndex === 'optReason' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 5
            }, [_createTextVNode(_toDisplayString(__props.prodChnl === "weixin" ? handleReason(record) : "-"), 1)], 64)) : _createCommentVNode("", true)];
          }),
          _: 1
        }, 8, ["columns", "data-source"])]),
        _: 1
      }, 8, ["open", "confirm-loading"]), _createVNode(_component_a_modal, {
        open: _unref(sseMessageModal),
        "onUpdate:open": _cache[1] || (_cache[1] = $event => _isRef(sseMessageModal) ? sseMessageModal.value = $event : null),
        title: "同步状态",
        onOk: _unref(handleSSEMessageModalOk),
        style: {
          "width": "500px"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(syncProductSSEMessage), (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, _toDisplayString(_unref(progressMap).get(item) ? _unref(progressMap).get(item) : item), 1);
        }), 128))]), _createElementVNode("div", _hoisted_4, [_createTextVNode(_toDisplayString(_unref(sseMessageLoading) ? "同步中..." : "同步完成") + " ", 1), _unref(sseMessageLoading) ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
          key: 0
        })) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["open", "onOk"])], 64);
    };
  }
});